import { DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO } from '@/const'
import EvaluacionDesempenio from './EvaluacionDesempenio'

const DEFAULT_EVALUACION_STATUS = 1

// TODO: Validar si es necesario props para puntaje total, calificación y idResultado, ya que son valores computados.
export default class EvaluacionRespetoPrincipios extends EvaluacionDesempenio {
  idEstatus
  reactivos
  observaciones
  puntajeTotal
  calificacion
  idResulado

  constructor(idEvaluado) {
    super(idEvaluado)
    this.idEstatus = DEFAULT_EVALUACION_STATUS
    this.reactivos = []
    this.observaciones = ''
    this.puntajeTotal = 0
    this.calificacion = DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO
    this.idResulado = null
  }
}
